"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MainForPanel = exports.SingleItemEdit = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _officeUiFabricReact = require("office-ui-fabric-react"),
    _reactRedux = require("react-redux"),
    _navigate = require("./navigate"),
    _reactReduxFirebase = require("react-redux-firebase"),
    _TableForm = require("../TableForm"),
    _index = require("./index"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _cloneDeep = require("lodash/cloneDeep"),
    _cloneDeep2 = _interopRequireDefault(_cloneDeep),
    _set = require("lodash/set"),
    _set2 = _interopRequireDefault(_set),
    _onRecordSave = require("./onRecordSave"),
    _useDbStore = require("./useDbStore");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function disablePrimaryField(a, b, c) {
  if (c) {
    var d = (0, _cloneDeep2.default)(a);
    return d.map(function (a) {
      a.name === b && (0, _set2.default)(a, ["props", "disabled"], !0);
    }), d;
  }

  return a;
}

var SingleItemEdit = exports.SingleItemEdit = _react2.default.memo(function (a) {
  var b = a.rec,
      c = b === void 0 ? {} : b,
      d = a.goBack,
      e = a.Config,
      f = (0, _extends3.default)({}, (0, _get2.default)(e, "formDefaults", {}), c),
      g = e.formValidator,
      h = (0, _useDbStore.useDbStore)(e),
      i = (0, _react.useCallback)(function (a, b, c) {
    return (0, _onRecordSave.onRecordSave)({
      data: a,
      success_callback: b,
      failure_callback: c,
      values: f,
      Config: e,
      dbStore: h
    });
  }, [f]),
      j = (0, _react.useMemo)(function () {
    return disablePrimaryField(e.formFields, e.primaryKey, !(!c || !(e.primaryKey in c)) && e.disableEditPrimaryKey);
  }, [e.formFields, e.disableEditPrimaryKey, c]),
      k = (0, _get2.default)(e, ["storageNameSpace", "namespace"], null),
      l = (0, _get2.default)(e, ["storageNameSpace", "firebaseStorage"], null),
      m = (0, _get2.default)(e, "renderSingleItemForm", null),
      n = {
    formFields: j,
    formValidator: g,
    defaultValues: f,
    onSubmit: i,
    onDiscard: d,
    namespace: k,
    firebaseStorage: l
  };
  return m ? m(n) : k ? _react2.default.createElement(_TableForm.TableFormWithFiles, n) : _react2.default.createElement(_TableForm.TableForm, n);
}),
    Main = _react2.default.memo(function (a) {
  var b = a.match.params.pk_val,
      c = (0, _react.useContext)(_index.ConfigContext),
      d = (0, _react.useCallback)(function () {
    return (0, _navigate.gotoNext)(c.homeUrl(), a);
  }, []),
      e = (0, _reactRedux.useSelector)(function (a) {
    return c.singleItemSelector(a, b);
  });

  if (!!b) {
    if ((0, _reactReduxFirebase.isLoaded)(e) && (0, _reactReduxFirebase.isEmpty)(e)) return _react2.default.createElement(_officeUiFabricReact.MessageBar, null, c.noItemMsg);
    if (!(0, _reactReduxFirebase.isLoaded)(e)) return _react2.default.createElement(_officeUiFabricReact.Spinner, {
      size: _officeUiFabricReact.SpinnerSize.large
    });
  }

  return _react2.default.createElement("div", c.editContainerProps, _react2.default.createElement(_officeUiFabricReact.Text, {
    variant: "xLarge"
  }, b ? b : "New Record"), !b ? _react2.default.createElement(SingleItemEdit, {
    rec: {},
    goBack: d,
    Config: c
  }) : _react2.default.createElement(SingleItemEdit, {
    rec: e,
    goBack: d,
    Config: c
  }));
}),
    MainForPanel = exports.MainForPanel = _react2.default.memo(function (a) {
  var b = a.pk_val,
      c = a.goBack,
      d = (0, _react.useContext)(_index.ConfigContext),
      e = (0, _reactRedux.useSelector)(function (a) {
    return d.singleItemSelector(a, b);
  });

  if (!!b) {
    if ((0, _reactReduxFirebase.isLoaded)(e) && (0, _reactReduxFirebase.isEmpty)(e)) return _react2.default.createElement(_officeUiFabricReact.MessageBar, null, d.noItemMsg);
    if (!(0, _reactReduxFirebase.isLoaded)(e)) return _react2.default.createElement(_officeUiFabricReact.Spinner, {
      size: _officeUiFabricReact.SpinnerSize.large
    });
  }

  return _react2.default.createElement("div", d.editContainerProps, _react2.default.createElement(_officeUiFabricReact.Text, {
    variant: "xLarge"
  }, b ? b : "New Record"), !b ? _react2.default.createElement(SingleItemEdit, {
    rec: {},
    goBack: c,
    Config: d
  }) : _react2.default.createElement(SingleItemEdit, {
    rec: e,
    goBack: c,
    Config: d
  }));
});

exports.default = Main;